<template lang="pug">
div(v-if="processo.dadosCadastro")
  .flex
    .btn-versao
      span.title Versão do cadastro: &nbsp
      el-select.input(
        class="select",
        v-model="versaoSelecionada",
        placeholder="Versões",
        @change="changeVersao"
        no-match-text="Nenhuma versão encontrada",
      )
        el-option(
          v-for="item in versoes",
          :key="item",
          :label="item",
          :value="item"
        )

    el-button.btn-action(
      v-if="showBtnSegundaVia && !isRelatorio"
      tipo="text",
      @click="emitirSegundaVia",
      @emitirSegundaVia="emitirSegundaVia()"
    )
      i.fal.fa-download
      | &nbsp Segunda via do comprovante de envio
  .dados-cadastro
    cadastro-online(
      v-if="getIsOnline()"
      :processoRelatorio="processo"
      :isRelatorio="true"
      :idProcesso="idProcesso"
      :versaoCadastro = "versaoSelecionada"
    )
    div(v-else-if="getIsUc()")
      cadastro-uc(
        v-if="dadosJson"
        :dadosJson="dadosJson"
      )
    div(v-else-if="getIsRf()")
      cadastro-rf(
        v-if="dadosJson"
        :dadosJson="dadosJson"
      )
    cadastro-offline(v-else :processo="processo" :isRelatorio="true", :versaoSelecionada="versaoSelecionada" :versaoCadastro = "versaoSelecionada")

</template>
<script>
import { mapActions } from 'vuex'
import CadastroOffline from '@/components/InformacoesCadastroOffline'
import CadastroOnline from '@/components/informacoesCadastro/cadastrosOnline/InformacoesCadastroOnline.vue'
import CadastroUc from '../../../../../components/informacoesCadastro/cadastrosOnline/CadastroUc.vue'
import CadastroRf from '../../../../../components/informacoesCadastro/cadastrosOnline/CadastroRf.vue'

export default {
  components: {
    CadastroOffline,
    CadastroOnline,
    CadastroUc,
    CadastroRf
  },
  props: {
    idProcesso: {
      type: Number,
      required: true
    },
    numeroProcesso: {
      type: String,
      required: true
    },
    protocolo: {
      type: String,
      required: true
    },
    showBtnSegundaVia: {
      type: Boolean,
      default: true
    },
    showBtnExportar: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      processo: {},
      versoes: [],
      dadosJson: null,
      versaoSelecionada: {},
      codigosProcessosOnline: ['PERMUTA', 'INFORMACOES', 'TRANSFERENCIA_DIREITOS', 'AFORAMENTO', 'AREAS_PATRIMONIAIS', 'CANCELAMENTO_CLAUSULA_RESOLUTIVA', 'REURB_COLETIVO'],
      codigoProcessoUc: ['UC'],
      codigoProcessoRf: ['RF']
    }
  },

  computed: {
    cadastroOriginal () {
      if (this.getIsOnline()) {
        if (!this.processo) {
          return null
        }
        return { ...this.processo.dadosCadastro, protocolo: this.processo.numeroProtocolo, tipo: this.processo.tipo.codigo }
      }
      return this.processo.dadosCadastro.dados.cadastro
    },
    isRelatorio () {
      return this.$router.currentRoute.name === 'relatorios/home'
    }

  },

  async created () {
    this.versoes = await this.getVersoesByProtocolo(this.protocolo)
    this.versaoSelecionada = this.versoes[0]
    this.$store.commit('processos/SET_VERSAO_SELECIONADA', this.versaoSelecionada)
    this.processo = await this.getProcesso(
      {
        protocolo: this.protocolo,
        versao: this.versaoSelecionada
      }
    )
    if (this.getIsUc()) {
      this.dadosJson = this.processo.dadosCadastro.cadastroUc
    }

    if (this.getIsRf()) {
      this.dadosJson = this.processo.dadosCadastro
    }
    // this.getComparar()
  },

  methods: {
    ...mapActions({
      getProcesso: 'processos/getProcessoByProtocoloAndVersao',
      getVersoesByProtocolo: 'processos/getVersoesByProtocolo',
      gerarSegundaVia: 'cadastro/emitirSegundaVia',
      getJsonCadastroUc: 'cadastroUc/getJson',
      getJsonCadastroRf: 'cadastroRf/getJsonRf'
    }),
    getIsUc () {
      return this.codigoProcessoUc.includes(this.processo.tipo.codigo)
    },
    getIsRf () {
      return this.codigoProcessoRf.includes(this.processo.tipo.codigo)
    },

    getIsOnline () {
      return this.codigosProcessosOnline.includes(this.processo.tipo.codigo)
    },

    async changeVersao () {
      this.$store.commit('processos/SET_VERSAO_SELECIONADA', this.versaoSelecionada)
      this.processo = await this.getProcesso(
        {
          protocolo: this.protocolo,
          versao: this.versaoSelecionada
        }
      )
      if (this.getIsUc()) {
        this.dadosJson = this.processo.dadosCadastro.cadastroUc
      }

      if (this.getIsRf()) {
        this.dadosJson = this.processo.dadosCadastro.cadastroRf
      }
    },

    emitirSegundaVia () {
      const params = {
        protocoloCadastro: this.cadastroOriginal.protocolo,
        nomeInteressado: this.cadastroOriginal.interessado.pessoa.pessoaFisica
          ? this.cadastroOriginal.interessado.pessoa.pessoaFisica.nome : this.cadastroOriginal.interessado.pessoa.pessoaJuridica.razaoSocial,
        tipo: this.getTipoProcesso()
      }
      this.gerarSegundaVia(params)
    },

    getTipoProcesso () {
      switch (this.cadastroOriginal.tipo) {
        case 'NAO_ONEROSO':
          return 'Não Oneroso'
        case 'ONEROSO':
          return 'Oneroso'
        case 'PEAS':
          return 'PEAS'
        case 'PEAEX':
          return 'PEAEX'
        case 'TEQ':
          return 'TEQ'
        case 'CERTIDAO_TITULO':
          return 'Certidão de Título'
        case 'AREAS_PATRIMONIAIS':
          return 'Áreas Patrimoniais'
        case 'INFORMACOES':
          return 'Informação'
        case 'PERMUTA':
          return 'Permuta'
        case 'TRANSFERENCIA_DIREITOS':
          return 'Transferência de Direitos'
        case 'AFORAMENTO':
          return 'Aforamento'
        default:
          return this.cadastroOriginal.tipo
      }
    }
  }
}
</script>

<style scoped>
.modal {
  height: 71vh;
}

.flex {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.margin10 {
  margin-top: 10px;
  color: #303133;
}

.tabContent {
  padding: 2%;
}

.pointer {
  cursor: pointer;
  color: #289f61;
}

.title {
  font-weight: 400;
  color: #909399;
  font-size: 16px;
}

.dados-cadastro {
  padding: 25px 0;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/pa/AppVisualizarCadastroTab.vue